import './SearchFilesContainer.css';
import React from 'react';
import { ViewTypesTabs } from 'src/components/SearchFilesContainer/ViewTypesTabs/ViewTypesTabs';
import { SortFilesDropdown } from 'src/components/SearchFilesContainer/SortFilesDropdown/SortFilesDropdown';
import { clsx } from 'clsx';
import { SearchInput } from 'src/components/SearchInput/SearchInput';

export const SearchFilesContainer = ({
  hideSearch = false,
  hideSort = false,
  hideViewType = false,
  onSearch,
  onSortFilesChange = undefined,
  onViewTypeChange = undefined,
}: {
  hideSearch?: boolean;
  hideSort?: boolean;
  hideViewType?: boolean;
  onSearch?: any;
  onSortFilesChange?: any;
  onViewTypeChange?: any;
}) => {
  const handleFileSearch = (value) => {
    onSearch && onSearch(value.length >= 1 ? value : '');
  };

  return (
    <div className="search-files-container flex flex-row justify-end gap-[10px] flex-1 relative">
      {!hideSearch && (
        <SearchInput
          className={clsx('!min-h-[34px] !right-0')}
          inputClassName={'!max-h-[34px]'}
          onChange={handleFileSearch}
          offsetLeft={false}
        />
      )}
      {!hideSort && <SortFilesDropdown onSortFilesChange={onSortFilesChange} />}
      {!hideViewType && <ViewTypesTabs onViewTypeChange={onViewTypeChange} />}
    </div>
  );
};
